import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as $ from 'jquery';

@Component({
  selector: 'app-step-by-step-videos',
  templateUrl: './step-by-step-videos.component.html',
  styleUrls: ['./step-by-step-videos.component.scss']
})
export class StepByStepVideosComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/home_client_slider.js', function () { });
      document.getElementById('footer').classList.add('d-none');
      document.getElementById('header').classList.add('d-none');
    }
  }

  stopAllVideos() {
    const iframes = document.querySelectorAll('iframe.youtubeVideoForTryDemo');
    iframes.forEach((iframe: HTMLIFrameElement) => {
      iframe.src = iframe.src; // Setting src to the same value pauses the video
    });
  }

}
